import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
    CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const NewChatDialog = ({ open, onClose, onCreateChat, projectName, isCreating }) => {
    const { t } = useTranslation();
    const [chatName, setChatName] = useState('');

    const handleSubmit = () => {
        onCreateChat(chatName.trim() || null);
        setChatName('');
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth data-testid="new-chat-dialog">
            <DialogTitle>
                {t('projects.newChatTitle', { projectName })}
            </DialogTitle>

            <DialogContent>
                <Typography variant="body2" color="text.secondary" paragraph>
                    {t('projects.newChatDescription')}
                </Typography>

                <TextField
                    autoFocus
                    margin="dense"
                    label={t('projects.chatName')}
                    placeholder={t('projects.chatNamePlaceholder')}
                    fullWidth
                    value={chatName}
                    onChange={(e) => setChatName(e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' && !isCreating) {
                            handleSubmit();
                        }
                    }}
                    disabled={isCreating}
                    data-testid="chat-name-input"
                />

                <Typography variant="caption" color="text.secondary">
                    {t('projects.chatNameOptional')}
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} disabled={isCreating}>
                    {t('cancel')}
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    disabled={isCreating}
                    startIcon={isCreating ? <CircularProgress size={20} /> : null}
                    data-testid="create-chat-button"
                >
                    {isCreating ? t('creating') : t('create')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NewChatDialog;